export const InvitationType = Object.freeze({
  ScheduleEvent: 'schedule-event',
});
